import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.location.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.location.fields.name'),
  },
  {
    name: 'parentLocation',
    label: i18n('entities.location.fields.parentLocation'),
    render: exporterRenders.relationToOne(),
  },
];
